import React from 'react';

const Terms = () => (
  <div className="container py-24 min-h-screen">
    <h1 className="text-3xl font-bold mb-6">Terms of Service</h1>
    <p className="mb-4">
      Welcome to my portfolio website. By accessing or using this website, you agree to be bound by the following terms and conditions. Please read them carefully.
    </p>

    <h2 className="text-xl font-semibold mt-6 mb-2">1. Use of Content</h2>
    <p className="mb-4">
      All content on this website, including text, graphics, and media, is the intellectual property of the site owner unless otherwise stated. You may view and share content for personal, non-commercial purposes only.
    </p>

    <h2 className="text-xl font-semibold mt-6 mb-2">2. No Warranties</h2>
    <p className="mb-4">
      This website is provided "as is" without any warranties of any kind. While I strive to keep content accurate and up-to-date, I make no guarantees about its completeness, reliability, or relevance.
    </p>

    <h2 className="text-xl font-semibold mt-6 mb-2">3. External Links</h2>
    <p className="mb-4">
      This website may contain links to third-party websites. I am not responsible for the content or practices of those websites.
    </p>

    <h2 className="text-xl font-semibold mt-6 mb-2">4. Modifications</h2>
    <p className="mb-4">
      I reserve the right to update or modify these terms at any time. Changes will be posted on this page.
    </p>

    <p className="text-muted-foreground">Last updated: {new Date().toLocaleDateString()}</p>
    <div className="mt-8 flex justify-center">
      <a href="/" className="inline-block px-4 py-2 bg-primary text-white rounded hover:bg-primary/90 transition-colors shadow">
        &larr; Return to Home
      </a>
    </div>
  </div>
);

export default Terms;
